
import Vue from 'vue';

// Services and types
import { Widget } from '~/services/types/organization';

// Components
import Card from '~/components/profile/cards/Card.vue';

export default Vue.extend({
    name: 'ProfileWidgetCard',
    components: { Card },
    props: {
        widget: {
            type: Object as () => Widget,
            required: true,
        },
    },
    methods: {
        handleOnClick() {
            if (this.widget.link) {
                window.open(this.widget.link, '_blank', 'noopener noreferrer');
            }
        },
    },
});
